import { useState } from 'react';
import './ChatWidget.css';

const ChatWidget = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [input, setInput] = useState('');
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const sendMessage = async () => {
    if (!input.trim()) return;

    const userMessage = { role: 'user', content: input };
    setMessages([...messages, userMessage]);
    setInput('');
    setLoading(true);
    setError(null);

    try {
      // Wrap the user text in the MCP “user_query” envelope
      const payload = {
        method: 'user_query',
        params: { message: input }
      };
      const res = await fetch(`${process.env.REACT_APP_MCP_API_BASE}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      // Handle both new `answer` and legacy `reply` keys
      if (data.answer) {
        setMessages((prev) => [...prev, { role: 'assistant', content: data.answer }]);
      } else if (data.reply) {
        setMessages((prev) => [...prev, { role: 'assistant', content: data.reply }]);
      } else if (data.error) {
        setError(data.error.message || 'Unexpected error');
      }
    } catch (err) {
      setError('Network error or server unavailable.');
    }

    setLoading(false);
  };

  return (
    <div className="chat-widget-container">
      {!isOpen && (
        <button className="chat-toggle-button" onClick={() => setIsOpen(true)}>
          💬 Chat
        </button>
      )}

      {isOpen && (
        <div className="chat-box">
          <div className="chat-header">
            <span>InsightBot</span>
            <button onClick={() => setIsOpen(false)}>✕</button>
          </div>
          <div className="chat-messages">
            {messages.map((msg, index) => (
              <div key={index} className={`chat-message ${msg.role}`}>
                <div className="chat-bubble">{msg.content}</div>
              </div>
            ))}
            {loading && <div className="chat-message assistant"><div className="chat-bubble loading">Thinking...</div></div>}
            {error && <div className="chat-error">{error}</div>}
          </div>
          <div className="chat-input">
            <textarea
              rows={2}
              placeholder="Ask a question..."
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' && !e.shiftKey) {
                  e.preventDefault();
                  sendMessage();
                }
              }}
            />
            <button onClick={sendMessage} disabled={loading}>Send</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ChatWidget;
